module.exports = __webpack_public_path__ + "img/p16.21876456.jpg";